import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  {
    path: 'login',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  {
    path: '',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin', 'profesional'] },
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'alumnos',
        loadChildren: () =>
          import('./pages/page-alumnos-inscriptos/page-alumnos-inscriptos.routes').then(
            (m) => m.ALUMNOS_ROUTES,
          ),
      },
      {
        path: 'plantillas',
        loadChildren: () =>
          import('./pages/page-plantillas-list/plantillas.routes').then(
            (m) => m.PLANTILLAS_ROUTES,
          ),
      },
    ],
  },

  { path: '**', redirectTo: 'home' },
];
